// front-end/src/components/cases-loader/cases-loader.js

import { apiGet } from '../../utils/api';
import { isAuthenticated } from '../auth';
import { initSortable } from '../block-system/block-manager/block-sortable';
import { loadContentForNewElements } from '../content-editor-src';
import { createAndTrackBlock } from '../block-system/block-manager/block-renderer';
import { setupMobileCaseAccordion } from '../block-system/block-configs/block-types/case-card';
import { config } from '../../config/app-config';

export class CasesLoader {
    constructor() {
        console.log('[CasesLoader] Инициализация начата');
        this.currentOffset = 0;
        this.itemsPerPage = 6;
        this.isLoading = false;
        this.hasMoreCases = true;
        this.container = null;
        this.loadMoreButton = null;
        this.isAuthenticated = isAuthenticated();
        this.initialized = false;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => this.init(), 100);
            });
        } else {
            setTimeout(() => this.init(), 100);
        }
    }

    init() {
        if (this.initialized) {
            console.log('[CasesLoader] Уже инициализирован, пропускаем');
            return;
        }

        console.log('[CasesLoader] init() - начало');

        try {
            const { initializeBlockCounters } = require('../block-system/block-manager/block-state');
            initializeBlockCounters();
            console.log('[CasesLoader] Счетчики блоков инициализированы');
        } catch (error) {
            console.error('[CasesLoader] Ошибка инициализации счетчиков:', error);
        }

        if (window.location.pathname.match(/cases(\.html)?$/)) {
            console.log('[CasesLoader] Страница cases - ищем контейнер');
            this.initElements();
        } else {
            console.log('[CasesLoader] Не страница cases, пропускаем инициализацию');
        }
    }

    initElements() {
        this.container = document.querySelector('[data-section="cases-section"]');
        this.loadMoreButton = document.querySelector('.load-more-');

        console.log('[CasesLoader] Контейнер найден:', !!this.container);
        console.log('[CasesLoader] Кнопка загрузки найдена:', !!this.loadMoreButton);

        if (this.container) {
            this.initialized = true;
            console.log('[CasesLoader] Настраиваем обработчики');

            if (this.container.dataset.ssr === 'true') {
                this.currentOffset = this.container.querySelectorAll('[data-block-name]').length;
                console.log(`[CasesLoader] SSR контент обнаружен: ${this.currentOffset} кейсов`);
                this.container.querySelectorAll('.case-slide').forEach(card => {
                    setupMobileCaseAccordion(card);
                });
            } else {
                this.clearContainer();
            }

            if (this.isAuthenticated) {
                initSortable(this.container);
            }

            this.setupLoadMoreButton();

            if (this.container.dataset.ssr !== 'true') {
                this.loadInitialCases();
            }
        } else {
            console.warn('[CasesLoader] Контейнер cases-section не найден!');
        }
    }

    clearContainer() {
        const nonBlockElements = Array.from(this.container.children).filter(
            child => !child.hasAttribute('data-block-name')
        );
        this.container.innerHTML = '';
        nonBlockElements.forEach(element => this.container.appendChild(element));
        console.log('[CasesLoader] Контейнер очищен, сохранены не блочные элементы');
    }

    setupLoadMoreButton() {
        if (this.loadMoreButton) {
            const newButton = this.loadMoreButton.cloneNode(true);
            this.loadMoreButton.parentNode.replaceChild(newButton, this.loadMoreButton);
            this.loadMoreButton = newButton;

            this.loadMoreButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('[CasesLoader] Кнопка "загрузить больше" нажата');
                this.loadMoreCases();
            });

            console.log('[CasesLoader] Кнопка "загрузить больше" настроена');
        }
    }

    async loadInitialCases() {
        console.log('[CasesLoader] loadInitialCases() - начало');

        try {
            this.currentOffset = 0;
            this.hasMoreCases = true;
            await this.loadCasesChunk(0);
        } catch (error) {
            console.error('[CasesLoader] Ошибка при загрузке начальных кейсов:', error);
            this.renderErrorState();
        }
    }

    async loadMoreCases() {
        if (this.isLoading || !this.hasMoreCases) {
            console.log('[CasesLoader] Загрузка уже идет или нет больше кейсов');
            return;
        }

        console.log('[CasesLoader] loadMoreCases() - загружаем еще кейсы');
        console.log(`[CasesLoader] Текущий offset: ${this.currentOffset}`);

        try {
            await this.loadCasesChunk(this.currentOffset);
        } catch (error) {
            console.error('[CasesLoader] Ошибка при загрузке дополнительных кейсов:', error);
            this.showLoadMoreError();
        }
    }

    async loadCasesChunk(offset) {
        console.log(`[CasesLoader] loadCasesChunk() - offset: ${offset}, limit: ${this.itemsPerPage}`);

        this.isLoading = true;
        this.updateLoadMoreButton('loading');

        try {
            let apiUrl = `${config.api.paths.casesOffset}?offset=${offset}&limit=${this.itemsPerPage}`;
            if (!this.isAuthenticated) {
                apiUrl += `&status=published`;
            }
            console.log('[CasesLoader] API URL:', apiUrl);

            const response = await apiGet(apiUrl, { auth: false });
            console.log('[CasesLoader] Ответ получен:', response);

            // Бэкенд теперь возвращает только кейсы, фильтрация не нужна
            let caseItems = Array.isArray(response) ? response : [];
            console.log(`[CasesLoader] Кейсов от API: ${caseItems.length}`);

            if (caseItems.length > 0) {
                await this.processCasesChunk(caseItems);

                this.currentOffset += caseItems.length;
                console.log(`[CasesLoader] Offset обновлен до: ${this.currentOffset}`);

                if (caseItems.length < this.itemsPerPage) {
                    console.log('[CasesLoader] Получено меньше кейсов чем запрашивали - это последний чанк');
                    this.hasMoreCases = false;
                    this.updateLoadMoreButton('no-more');
                } else {
                    this.updateLoadMoreButton('ready');
                }
            } else {
                if (offset === 0) {
                    console.log('[CasesLoader] Кейсы не найдены - показываем пустое состояние');
                    this.renderEmptyState();
                }
                this.hasMoreCases = false;
                this.updateLoadMoreButton('no-more');
            }

            // Загружаем контент для всех блоков в контейнере
            loadContentForNewElements(this.container.querySelectorAll('[data-content]'));
        } catch (error) {
            console.error('[CasesLoader] Ошибка при загрузке чанка кейсов:', error);
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    async processCasesChunk(caseItems) {
        console.log(`[CasesLoader] processCasesChunk() - обрабатываем ${caseItems.length} кейсов`);

        for (let i = 0; i < caseItems.length; i++) {
            const caseData = caseItems[i];
            const blockData = {
                id: caseData.block_id,
                class_name: 'case-card',
                data_block_name: caseData.slug,
                order: this.currentOffset + i
            };

            console.log(`[CasesLoader] Создаем блок для ${caseData.slug}`);

            const blockElement = createAndTrackBlock(blockData, this.container);
            if (blockElement) {
                blockElement.setAttribute('data-news-id', caseData.id);
                blockElement.setAttribute('data-news-status', caseData.status || 'draft');
                blockElement.setAttribute('data-news-slug', caseData.slug);

                if (this.isAuthenticated && window.caseManager && caseData.id) {
                    window.caseManager.addStatusControlsToBlock(blockElement, caseData.id);
                    console.log(`[CasesLoader] Добавлены контролы статуса для ${caseData.slug}`);
                } else if (!this.isAuthenticated) {
                    const statusIndicator = blockElement.querySelector('.news-status-indicator');
                    if (statusIndicator) {
                        statusIndicator.remove();
                    }
                }

                this.updateCaseLink(blockElement, caseData.slug, caseData.status);
            } else {
                console.warn(`[CasesLoader] Не удалось создать блок для ${caseData.slug}`);
            }
        }
    }

    updateCaseLink(blockElement, caseSlug, caseStatus) {
        const caseLink = blockElement.querySelector('a.news-link-to-feed-container');
        if (caseLink && caseSlug) {
            // ИСПРАВЛЕНИЕ: Авторизованные пользователи могут видеть все кейсы
            const shouldActivateLink = caseStatus === 'published' || this.isAuthenticated;
            const dynamicUrl = shouldActivateLink ? `/case/${caseSlug}` : '#';

            caseLink.href = dynamicUrl;
            caseLink.setAttribute('data-page', caseSlug);
            caseLink.classList.toggle('active', shouldActivateLink);
            caseLink.classList.toggle('inactive', !shouldActivateLink);

            // Только для неавторизованных пользователей блокируем клики на черновики
            if (!shouldActivateLink) {
                caseLink.style.pointerEvents = 'none';
                caseLink.style.opacity = '0.5';
            } else {
                caseLink.style.pointerEvents = '';
                caseLink.style.opacity = '';
            }

            console.log(`[CasesLoader] Ссылка обновлена для ${caseSlug}: ${dynamicUrl} (authenticated: ${this.isAuthenticated}, status: ${caseStatus})`);
        }
    }

    updateLoadMoreButton(state) {
        if (!this.loadMoreButton) return;

        switch (state) {
            case 'loading':
                this.loadMoreButton.textContent = 'завантажується...';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                break;

            case 'ready':
                this.loadMoreButton.textContent = 'завантажити більше';
                this.loadMoreButton.disabled = false;
                this.loadMoreButton.style.opacity = '1';
                this.loadMoreButton.style.display = 'block';
                break;

            case 'no-more':
                this.loadMoreButton.textContent = 'усі кейси завантажено';
                this.loadMoreButton.disabled = true;
                this.loadMoreButton.style.opacity = '0.6';
                setTimeout(() => {
                    if (this.loadMoreButton) {
                        this.loadMoreButton.style.display = 'none';
                    }
                }, 3000);
                break;
        }
    }

    showLoadMoreError() {
        if (this.loadMoreButton) {
            this.loadMoreButton.textContent = 'помилка завантаження';
            this.loadMoreButton.disabled = false;
            this.loadMoreButton.style.opacity = '1';

            setTimeout(() => {
                this.updateLoadMoreButton('ready');
            }, 3000);
        }
    }

    renderEmptyState() {
        console.log('[CasesLoader] renderEmptyState()');
        this.container.innerHTML = `
            <div class="cases-empty-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <h3>Кейси скоро з'являться</h3>
                <p>Наразі немає опублікованих кейсів</p>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    renderErrorState() {
        console.log('[CasesLoader] renderErrorState()');
        this.container.innerHTML = `
            <div class="cases-error-state" style="text-align: center; padding: 40px; grid-column: 1 / -1;">
                <h3>Не вдалося завантажити кейси</h3>
                <p>Спробуйте оновити сторінку</p>
                <button onclick="location.reload()" style="
                    padding: 10px 20px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-top: 10px;
                ">Оновити сторінку</button>
            </div>
        `;

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = 'none';
        }
    }

    async reload() {
        console.log('[CasesLoader] Перезагрузка кейсов');
        this.currentOffset = 0;
        this.hasMoreCases = true;
        this.clearContainer();
        await this.loadInitialCases();
    }
}

export const casesLoader = new CasesLoader();